import { Model } from "@vuex-orm/core";
import { findIndex, orderBy } from "lodash";
import { TicketHelper } from "../../helper/ticket-helper";
import { CommonHelper } from "../../helper/common-helper";

export interface customStatusEntity {
  ticketStatusId: number;
  baseStatusId: number;
  name: string;
  description: string;
  color: string;
  isDefault: boolean;
  sortOrder: number;
  isActive: boolean;
}
export class customStatusEntity extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = "customStatusEntity";
  static primaryKey = "ticketStatusId";

  static fields() {
    return {
      ticketStatusId: this.number(0),
      baseStatusId: this.number(0),
      name: this.string(""),
      description: this.string(""),
      color: this.string(""),
      isDefault: this.boolean(false),
      sortOrder: this.number(""),
      isActive: this.boolean(true),
    };
  }

  static beforeSelect(records: any) {
    return orderBy(
      records,
      ["customSortOrder", "sortOrder"],
      ["asc", "asc"],
    );
  }

  get id() {
    return this.ticketStatusId;
  }

  get customStatusesInBaseStatus() {
    return customStatusEntity
      .query()
      .where("baseStatusId", this.baseStatusId)
      .where("isActive", true)
      .orderBy("sortOrder", "asc")
      .all();
  }

  get indexOfCurrentStatus(): number {
    let currentTicketStatusId = this.ticketStatusId;

    return findIndex(this.customStatusesInBaseStatus, function (status) {
      return status.ticketStatusId == currentTicketStatusId;
    });
  }

  get customStatusesInBaseStatusCount(): number {
    return this.customStatusesInBaseStatus.length;
  }

  get percentageOfStatusIcon() {
    if (this.indexOfCurrentStatus < 0) {
      return 0;
    }

    return TicketHelper.calculatePercentageOfTicketStatus(
      this.baseStatusId,
      this.customStatusesInBaseStatusCount,
      this.indexOfCurrentStatus,
    );
  }

  get customSortOrder() {
    return CommonHelper.getTicketStatusSortOrder(this.baseStatusId);
  }

  get statusIcon() {
    return TicketHelper.getTicketStatusIcon(this.baseStatusId);
  }
}
